export function bytes_literal() { return "bytes"; }